import { render, staticRenderFns } from "./personalInfor.vue?vue&type=template&id=9c1468a0&scoped=true&"
import script from "./personalInfor.vue?vue&type=script&lang=js&"
export * from "./personalInfor.vue?vue&type=script&lang=js&"
import style0 from "./personalInfor.vue?vue&type=style&index=0&id=9c1468a0&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1468a0",
  null
  
)

export default component.exports